import { library } from '@fortawesome/fontawesome-svg-core';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
library.add(faChartBar);

export const EmptyStatistics = observer((): ReactElement => {
  const { t } = useTranslator();

  return (
    <div className='empty-statistics'>
      <div className='please-select-statistic-message'>
        <div className='chart-icon'>
          <FontAwesomeIcon icon={faChartBar} />
        </div>
        <h5>{t('please_select_statistics')}</h5>
      </div>
    </div>
  );
});
